import React from "react";
import styles from "./style.module.css";
import { Popover } from "react-bootstrap";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import { useSelector, useDispatch } from "types/store";
import * as viewReducer from "containers/View/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import Tooltip from "components/Inputs/Tooltip";
import partyIcon from "images/ChatAible_Infographic/party.svg";
import { DEFAULT_BLUEPRINT_ID } from "containers/ChatGPT/reducer";
import { customMapper, selectOnChangeWrapper } from "utils/select";
const BlueprintSelector = ({ menuPlacement, hideSelect, isDisabled, isStyled, isNewChat, isDynamic, onChange, value, extraOptions, selectorStyle, color, popover, className, skipSearchFilter, style, innerRef, onChangeFocus, filterTypes, ...retProps }) => {
    const dispatch = useDispatch();
    const blueprints = useSelector((state) => viewReducer.getChatBlueprints(state));
    const selectedBlueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const showBlueprintPopup = useSelector((state) => chatGPTReducer.getShowBlueprintPopup(state));
    const MAPPER = customMapper((b) => b.label);
    const defaultOnChange = (val) => {
        dispatch(chatGPTReducer.updateShowRecommendedOptions(false));
        dispatch(chatGPTReducer.selectBlueprint(val?.value ?? val?.blueprintId ?? DEFAULT_BLUEPRINT_ID));
        if (onChangeFocus !== undefined && onChangeFocus !== null) {
            const focus = onChangeFocus?.current;
            if (focus) {
                focus?.focus();
            }
        }
    };
    const retBlueprints = (blueprints ?? []).map((bp) => {
        return {
            label: bp.name,
            value: bp.id,
            description: bp.wizard?.description,
            blueprintId: bp?.blueprintId,
            chatType: bp?.chatType,
            rawChatType: bp?.wizard?.chatGPT?.chatType
        };
    });
    const bpOptions = [
        ...retBlueprints,
        ...(extraOptions ?? [])
        // { label: "Ask For Dataset", value: "ASK_FOR_DATASET" },
        //{ label: "Multiple Datasets", value: "MULTI" },
        //{ label: "Ask Datasources", value: "AUTO_IMPORT"},
        //{ label: "Get SQL", value: "GET_SQL" },
    ].filter((b) => {
        if (b?.value === "CHATAIBLE_JUST_CHAT") {
            return false;
        }
        if (filterTypes?.length) {
            const bpType = b.rawChatType;
            if (!filterTypes.includes(bpType)) {
                return false;
            }
        }
        return true;
    });
    const retValue = bpOptions.find((o) => o?.value === (value !== undefined ? value : selectedBlueprintId));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.blueprintSelectorWrapper +
                " " +
                (isNewChat ? styles.isNewChat : "") +
                " " +
                (className ? className : ""), id: "chat-type-select", style: style, ...retProps }, !hideSelect && (React.createElement("div", { className: styles.blueprintSelector },
            popover ? popover : showBlueprintPopup && React.createElement(BlueprintPopup, null),
            React.createElement(DynamicWidthSelector, { components: { Option: CustomOption }, options: MAPPER.mapAll(bpOptions), value: MAPPER.map(retValue), onChange: selectOnChangeWrapper(onChange ?? defaultOnChange), placeholder: "Chat Style: Default", menuPlacement: menuPlacement ?? "top", isSearchable: true, isDisabled: isDisabled, isDynamic: isDynamic, isNewChat: isNewChat, isStyled: isStyled, style: selectorStyle, color: color, innerRef: innerRef }))))));
};
export default BlueprintSelector;
const BlueprintPopup = () => {
    const dispatch = useDispatch();
    return (React.createElement(Popover, { id: "blueprintSelectorPopup", className: styles.blueprintPopupContainer, placement: "top", positionTop: -80, onClick: () => {
            dispatch(chatGPTReducer.updateShowBlueprintPopup(false));
        } },
        React.createElement("div", { className: styles.blueprintPopup },
            React.createElement("div", { className: styles.blueprintPopupClose }, "X"),
            React.createElement("div", { className: styles.blueprintPopupImage },
                React.createElement("img", { src: partyIcon })),
            React.createElement("div", { className: styles.blueprintPopupText }, "ChatAible has automatically adjusted to an analytics agent template to optimize answers to your data questions"))));
};
const CustomOption = (option) => {
    return (React.createElement("div", { className: styles.cOption, ...option?.innerProps },
        React.createElement(Tooltip, { overlay: option?.data?.description, trigger: ["hover"] },
            React.createElement(React.Fragment, null, option?.data?.label))));
};
